// src/components/Home/HeroSlide.js
import React from 'react';

const HeroSlide = () => {
  return (
    <div
      className="relative overflow-hidden h-full"
      style={{
        backgroundImage: 'url(https://themewagon.github.io/soft-tech/assets/images/homebg.jpg)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      }}
    >
      <div className="max-w-6xl mx-auto h-full">
        <div className="relative flex items-center z-10 bg-gray-50 bg-opacity-80 sm:pb-16 md:pb-20 lg:max-w-3xl lg:w-full lg:pb-28 xl:pb-32 h-full">
          <div className="pt-10 mx-auto px-4 sm:pt-12 sm:px-6 md:pt-16 lg:pt-20 lg:px-8 xl:pt-28">
            <div className="text-center lg:text-left">
              <h1 className="text-4xl tracking-tight font-extrabold text-gray-900 sm:text-5xl md:text-6xl">
                <span className="block">Transformamos tu negocio con</span>
                <span className="block" style={{ color: 'blue-primary' }}>tecnología, estrategia</span>
                <span className="block" style={{ color: 'green-primary' }}>y energía</span>
              </h1>
              <p className="mt-3 text-base text-gray-500 sm:mt-5 sm:text-lg sm:max-w-xl sm:mx-auto lg:mx-0">
                No solo vendemos servicios, <span className="font-bold">ofrecemos soluciones reales</span> que transforman la forma en que trabajas, vendes o vives.
              </p>
              <div className="mt-5 sm:mt-8 sm:flex sm:justify-center lg:justify-start">
                <div className="rounded-md shadow">
                  <a
                    href='/contact' 
                    className="w-full flex items-center justify-center px-8 py-3 border border-transparent text-base font-medium rounded-md md:py-4 md:text-lg md:px-10 bg-salient-primary text-white hover:bg-salient-primary-hover"
                  >
                    Solicitar asesoría
                  </a>
                </div>
                <div className="mt-3 sm:mt-0 sm:ml-3">
                  <a
                    href="#why-choose"
                    className="w-full flex items-center justify-center px-8 py-3 border border-gray-200
                     text-base font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 md:py-4 md:text-lg md:px-10"
                  >
                    ¿Por qué elegirnos?
                  </a>
                </div>
              </div>
            </div>
          </div>
          <svg
            className="hidden lg:block absolute right-0 inset-y-0 h-full w-48 text-gray-50 transform translate-x-1/2"
            fill="currentColor"
            viewBox="0 0 100 100"
            preserveAspectRatio="none"
            aria-hidden="true"
          >
            <polygon points="50,0 100,0 50,100 0,100" />
          </svg>
        </div>
      </div>
    </div>
  );
};

export default HeroSlide;
